import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { X } from 'lucide-react';
export function Dialog({ open, onOpenChange, children }) {
    React.useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [open]);
    // Extract trigger and content from children
    const childArray = React.Children.toArray(children);
    const trigger = childArray.find((child) => React.isValidElement(child) && child.type === DialogTrigger);
    const otherChildren = childArray.filter((child) => !React.isValidElement(child) || child.type !== DialogTrigger);
    return (_jsxs(_Fragment, { children: [trigger, open && (_jsxs("div", { className: "fixed inset-0 z-50 flex items-center justify-center", children: [_jsx("div", { className: "fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity", onClick: () => onOpenChange(false) }), _jsx("div", { className: "relative z-50 w-full max-w-lg mx-4", children: otherChildren })] }))] }));
}
export function DialogContent({ children, className = '' }) {
    return (_jsx("div", { className: `bg-white rounded-lg shadow-xl p-6 animate-in fade-in-0 zoom-in-95 ${className}`, onClick: (e) => e.stopPropagation(), children: children }));
}
export function DialogHeader({ children, onClose }) {
    return (_jsxs("div", { className: "flex items-start justify-between mb-4", children: [_jsx("div", { className: "flex-1", children: children }), onClose && (_jsx("button", { onClick: onClose, className: "text-gray-400 hover:text-gray-600 transition-colors ml-4", "aria-label": "Close", children: _jsx(X, { className: "w-5 h-5" }) }))] }));
}
export function DialogTitle({ children }) {
    return _jsx("h2", { className: "text-xl font-semibold text-gray-900", children: children });
}
export function DialogDescription({ children }) {
    return _jsx("p", { className: "text-sm text-gray-600 mt-1", children: children });
}
export function DialogFooter({ children }) {
    return _jsx("div", { className: "flex items-center justify-end gap-3 mt-6", children: children });
}
export function DialogTrigger({ children, asChild, onClick }) {
    // When asChild is true, we clone the child and add onClick handler
    if (asChild && React.isValidElement(children)) {
        return React.cloneElement(children, {
            onClick: (e) => {
                e.preventDefault();
                if (onClick)
                    onClick();
                // Also call the original onClick if it exists
                const originalOnClick = children.props.onClick;
                if (originalOnClick)
                    originalOnClick(e);
            },
        });
    }
    // When not asChild, wrap in a button
    return (_jsx("button", { type: "button", onClick: onClick, children: children }));
}
